import script from "./ComputeFrictionPage.vue?vue&type=script&lang=ts&setup=true"
export * from "./ComputeFrictionPage.vue?vue&type=script&lang=ts&setup=true"

import "./ComputeFrictionPage.vue?vue&type=style&index=0&id=34064643&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-34064643"]])

export default __exports__